import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from 'components/Avatar/Avatar';
import IconButton from 'components/IconButton/IconButton';
import { CheckCircleIcon, CloseIcon, ProgressIcon } from 'components/icons';
import usePusherEvent from 'hooks/usePusherEvent';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const STORE_KEY = 'pl_status_banner_shown';

const MigrationBanner = () => {
  const [showBanner, setShowBanner] = useState('');
  const user = useSelector((s) => s.user.user);
  const isProgress = user?.pl_migration_status === 'in_progress';

  usePusherEvent('account', 'pl_migration_complete', () => {
    setShowBanner('complete');
  });

  useEffect(() => {
    if (isProgress) {
      const isStored = localStorage.getItem(STORE_KEY);
      if (isStored) {
        return;
      }
      setShowBanner('in_progress');
      localStorage.setItem(STORE_KEY, '1');
    }
  }, [isProgress]);

  const onClose = () => {
    setShowBanner('');
    localStorage.removeItem(STORE_KEY);
  };

  const renderBanner = ({ icon, iconColor, primary, secondary }) => {
    return (
      <ListItem
        divider
        secondaryAction={
          <IconButton
            onClick={onClose}
            icon={<CloseIcon />}
            variant="text"
            size="large"
          />
        }
      >
        <ListItemAvatar sx={{ mr: 2 }}>
          <Avatar size="xlarge" color={iconColor}>
            {icon}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={primary}
          secondary={secondary}
          primaryTypographyProps={{
            variant: 'h4',
            fontWeight: 600,
          }}
        />
      </ListItem>
    );
  };

  if (showBanner === 'in_progress') {
    return renderBanner({
      icon: <ProgressIcon sx={{ fontSize: 32 }} />,
      iconColor: 'primary',
      primary: 'Data Migration in Progress...',
      secondary:
        'Feel free to continue setting up your account while we transfer your data.',
    });
  }
  if (showBanner === 'complete') {
    return renderBanner({
      icon: <CheckCircleIcon sx={{ fontSize: 32 }} />,
      iconColor: 'success',
      primary: 'Data Successfully Migrated!',
      secondary: 'Your data is successfully transferred to Text In Church.',
    });
  }
  return null;
};

export default MigrationBanner;
